export const CREATED_BY_OPTIONS = [
  { value: "self", label: "Self" },
  { value: "father", label: "Father" },
  { value: "mother", label: "Mother" },
  { value: "brother", label: "Brother" },
  { value: "sister", label: "Sister" },
  { value: "friend", label: "Friend" },
  { value: "relatives", label: "Relatives" },
] as const;

const CREATED_BY_LABELS: Record<string, string> = {
  self: "Self",
  father: "Father",
  mother: "Mother",
  brother: "Brother",
  sister: "Sister",
  friend: "Friend",
  relatives: "Relatives",
  super_admin: "Super Admin",
  other_mediator: "Other Mediator",
  admin: "Admin",
};

export const normalizeCreatedBy = (value?: string | null): string => {
  const raw = (value || "").trim();
  if (!raw) return "";

  const normalized = raw.toLowerCase().replace(/[\s-]+/g, "_");

  if (normalized === "relative") return "relatives";
  if (normalized === "superadmin") return "super_admin";
  if (normalized === "otherbureau") return "other_mediator";
  if (normalized === "othermediaterprofile") return "other_mediator";
  if (normalized === "othermediatorprofile") return "other_mediator";
  if (normalized === "othermediator") return "other_mediator";

  return normalized;
};

export const formatCreatedBy = (value?: string | null): string => {
  const normalized = normalizeCreatedBy(value);
  if (!normalized) return "";
  return (
    CREATED_BY_LABELS[normalized] ||
    normalized.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
  );
};

export const isCreatedBySuperAdmin = (value?: string | null): boolean =>
  normalizeCreatedBy(value) === "super_admin";

export const isCreatedByOtherMediator = (value?: string | null): boolean =>
  normalizeCreatedBy(value) === "other_mediator";
